module.exports = __webpack_public_path__ + "static/media/TheHulk.4473ec50.jpg";